import { render } from "./CaseShow.vue?vue&type=template&id=f1156906&scoped=true"
import script from "./CaseShow.vue?vue&type=script&lang=js"
export * from "./CaseShow.vue?vue&type=script&lang=js"

import "./CaseShow.vue?vue&type=style&index=0&id=f1156906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1156906"]])

export default __exports__